import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	Button, FormGroup, InputGroup, FormControl,
} from 'react-bootstrap';
import {
	isEqual,
	isFunction,
	isNull,
} from 'lodash';

class SearchField extends Component {
	constructor() {
		super();

		this.state = {
			value : '',
		};
	}

	shouldComponentUpdate = ({ placeholder, externalValue }, { value }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(placeholder, lastProps.placeholder)
			|| !isEqual(externalValue, lastProps.externalValue)
			|| !isEqual(value, lastState.value)
		);
	}

	onChange = ({ target : { value } }) => this.setState({ value })

	onKeyPress = ({ key }) => {
		// Execute search onPress Enter
		if (key === 'Enter') this.onSearch();
	}

	onSearch = () => {
		const { onQuickSearch } = this.props;
		const { value } = this.state;
		onQuickSearch(value);
	}

	onClear = () => {
		const { onQuickSearch } = this.props;

		this.setState({ value : '' });

		onQuickSearch('');
	}

	render() {
		const {
			placeholder, isClearable, externalValue, onChange, onClear,
		} = this.props;
		const { value } = this.state;
		const formValue = isNull(externalValue) ? value : externalValue;

		return (
			<FormGroup>
				<InputGroup>
					<div className="search-field">
						<FormControl
							className="padding-right-30"
							name="search-field"
							value={formValue}
							placeholder={placeholder}
							onChange={isFunction(onChange) ? onChange : this.onChange}
							onKeyPress={this.onKeyPress}
						/>
						<If condition={isClearable && formValue !== ''}>
							<span
								className="'cursor-pointer clear-search rkf rkf-cross"
								onClick={isFunction(onClear) ? onClear : this.onClear}
								role="button"
								onKeyPress={null}
								tabIndex={0}
								aria-label="clear search"
							/>
						</If>
					</div>
					<InputGroup.Button>
						<Button
							onClick={this.onSearch}
						>
							<i className="rkf rkf-search text-primary" />
						</Button>
					</InputGroup.Button>
				</InputGroup>
			</FormGroup>
		);
	}
}

SearchField.propTypes = {
	onChange      : PropTypes.func,
	placeholder   : PropTypes.string,
	isClearable   : PropTypes.bool,
	onQuickSearch : PropTypes.func,
	onClear       : PropTypes.func,
	externalValue : PropTypes.string,
};

SearchField.defaultProps = {
	onChange      : undefined,
	placeholder   : '',
	isClearable   : true,
	onQuickSearch : () => { },
	onClear       : undefined,
	externalValue : null,
};

export default SearchField;
